import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { Staffs } from '@/modules/staffs/types';
import { CompaniesUsers } from '../../../types';

export default class CompaniesUsersManagersState extends BaseState {
  companies_users_managers: Staffs.Staff[] = [];
  companies_users: Pick<Staffs.Staff, 'id'|'name_company'>[] = [];
  companies_users_managers_loading = false;
  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['name_company'],
    sortDesc: [true],
  };

  filters: CompaniesUsers.CompaniesUsersManagersFilters = {
    search: '',
    company_id: null,
  };
}
